import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from "@angular/material/icon";
import {BasePatientPage} from "../../base-patient-page";
import {MatButton} from "@angular/material/button";
import {MatCheckbox} from "@angular/material/checkbox";
import {InsuranceInputComponent} from "../../../../components/insurance/insurance-input.component";
import {SurveyQuestions} from "@allaihealth/survey";

/** The insurance information for a patient */
@Component({
	selector: 'app-insurance',
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule,
		FormsModule,
		MatIconModule,
		MatButton,
		MatCheckbox,
		InsuranceInputComponent
	],
	templateUrl: './insurance.component.html',
	styleUrl: './insurance.component.scss',
})


export class InsuranceComponent extends BasePatientPage {

	override ngOnInit():void {
		super.ngOnInit();
		if(!this.patientInfo.data[SurveyQuestions.Insurances]) {
				this.patientInfo.data[SurveyQuestions.Insurances] = [{
					patientMrn: this.patient.mrn,
				}];
		}
	}

	protected addInsurance() {
		if(!this.patientInfo.data[SurveyQuestions.Insurances]) {
			this.patientInfo.data[SurveyQuestions.Insurances] = [];
		}
		if(this.patientInfo.data[SurveyQuestions.Insurances]?.length < 3) {
			this.patientInfo.data[SurveyQuestions.Insurances].push({
				provider: "",
				ehrEquivalent: "",
				patientMrn: this.patient.mrn,
				primaryHolder: "SELF",
				relationship: "SELF"
			});
		}
	}

	async completeAll() {
		await this.completeCategory(this.controller.insurance);
	}

	protected readonly SurveyQuestions = SurveyQuestions;
}
